import ContentHeader from './contentHeader';

export default ContentHeader;
